import { useDispatch } from "react-redux";
import api from "utils/api";

import { setHasChosenCommunicationPreferences } from "features/user/userSlice";
import { CONSENT_STATUS } from "utils/constants";
import checkUserConsent from "utils/checkUserConsent";

export default function useFetchConsentForProfile() {
  const dispatch = useDispatch();
  const fetchConsentForProfile = async (firebaseToken, profileId) => {
    try {
      const response = await api.getSubscriptionStatus(firebaseToken, profileId);
      if (response.data?.subscribed) {
        const hasChosen =
          response.data.subscribed === CONSENT_STATUS.REVOKED ||
          checkUserConsent(response.data.subscribed);
        dispatch(setHasChosenCommunicationPreferences(hasChosen));
      }
      return response.data;
    } catch (e) {
      console.error("Error fetching consent status:", e);
    }
  };

  return { fetchConsentForProfile };
}
